export default {
  invoices(state) {
    return state.invoices
  },
  transaction(state) {
    return state.transaction
  },
}
